// @generated-imports
import { applyFiltersAndRender, escapeAttribute, escapeHTML, slugify, truncate } from './app.js';
import { CONFIG, dom, state } from './core.js';
import { armButtonConfirm } from './datapanel.js';
import { isLayerOpen, layerClosed, layerOpened, openPromptLayer } from './layers.js';
import { describeOfflineStatus, isGameOffline, loadOfflineIndex, offlineCacheAvailable, offlineStatus } from './offline.js';
import { evaluateAchievements } from './stats.js';
// @generated-imports
/* ===========================================================================
   COLEÇÕES e "JOGAR DEPOIS" (v2.1)
   ---------------------------------------------------------------------------
   Listas do usuário (por perfil) que viram filtro no catálogo pelo campo
   "Lista" — ao lado de "⏳ Jogar depois" e "✈️ Offline". Entram no backup
   (chaves emutab:*) e o modo mesclar une as listas.
   ======================================================================== */

function loadCollections() {
  try {
    const list = JSON.parse(localStorage.getItem(CONFIG.localStorageCollectionsKey) || '[]');
    return Array.isArray(list) ? list.filter((c) => c && c.id && Array.isArray(c.games)) : [];
  } catch (_) { return []; }
}

function saveCollections(list) {
  try { localStorage.setItem(CONFIG.localStorageCollectionsKey, JSON.stringify(list)); } catch (_) {}
}

function loadPlayLater() {
  try {
    const list = JSON.parse(localStorage.getItem(CONFIG.localStoragePlayLaterKey) || '[]');
    return Array.isArray(list) ? list.map(String) : [];
  } catch (_) { return []; }
}

function isPlayLater(gameId) {
  return loadPlayLater().includes(gameId);
}

function togglePlayLater(gameId) {
  const list = loadPlayLater();
  const next = list.includes(gameId) ? list.filter((id) => id !== gameId) : [gameId].concat(list);
  try { localStorage.setItem(CONFIG.localStoragePlayLaterKey, JSON.stringify(next)); } catch (_) {}
  renderListFilterOptions();
  if (state.listFilter === 'play-later') applyFiltersAndRender();
  return next.includes(gameId);
}

function createCollection(name) {
  const clean = String(name || '').trim().slice(0, 32);
  if (!clean) return null;
  const list = loadCollections();
  let id = `c-${slugify(clean).slice(0, 20)}`;
  let n = 2;
  while (list.some((c) => c.id === id)) { id = `c-${slugify(clean).slice(0, 20)}-${n}`; n += 1; }
  const collection = { id, name: clean, games: [], createdAt: Date.now() };
  list.push(collection);
  saveCollections(list);
  renderListFilterOptions();
  evaluateAchievements();
  return collection;
}

function renameCollection(id, name) {
  const list = loadCollections();
  const found = list.find((c) => c.id === id);
  if (!found || !String(name || '').trim()) return false;
  found.name = String(name).trim().slice(0, 32);
  saveCollections(list);
  renderListFilterOptions();
  return true;
}

function deleteCollection(id) {
  saveCollections(loadCollections().filter((c) => c.id !== id));
  if (state.listFilter === `col:${id}`) { state.listFilter = 'all'; applyFiltersAndRender(); }
  renderListFilterOptions();
}

function toggleGameInCollection(collectionId, gameId) {
  const list = loadCollections();
  const found = list.find((c) => c.id === collectionId);
  if (!found) return false;
  found.games = found.games.includes(gameId) ? found.games.filter((id) => id !== gameId) : found.games.concat(gameId);
  saveCollections(list);
  renderListFilterOptions();
  if (state.listFilter === `col:${collectionId}`) applyFiltersAndRender();
  return found.games.includes(gameId);
}

function matchesListFilter(game) {
  const filter = state.listFilter || 'all';
  if (filter === 'all') return true;
  if (filter === 'play-later') return isPlayLater(game.id);
  if (filter === 'offline') return isGameOffline(game);
  if (filter.indexOf('col:') === 0) {
    const found = loadCollections().find((c) => `col:${c.id}` === filter);
    return Boolean(found && found.games.includes(game.id));
  }
  return true;
}

function renderListFilterOptions() {
  if (!dom.listFilter) return;
  const current = state.listFilter || 'all';
  const later = loadPlayLater().length;
  const offline = Object.keys(loadOfflineIndex()).length;
  const options = [['all', 'Todos'], ['play-later', `⏳ Jogar depois (${later})`], ['offline', `✈️ Offline (${offline})`]]
    .concat(loadCollections().map((c) => [`col:${c.id}`, `📚 ${c.name} (${c.games.length})`]));
  dom.listFilter.innerHTML = options.map(([value, label]) => `<option value="${escapeAttribute(value)}">${escapeHTML(label)}</option>`).join('');
  dom.listFilter.value = options.some(([value]) => value === current) ? current : 'all';
  if (dom.listFilter.value !== current) state.listFilter = 'all';
}

/* --- Painel -------------------------------------------------------------- */

function openCollectionsPanel(game) {
  if (!dom.collectionsModal) return;
  state.collectionsGame = game || null;
  const list = loadCollections();
  dom.collectionsTitle.textContent = game ? `📚 Coleções — ${truncate(game.title, 30)}` : '📚 Suas coleções';
  const rows = list.map((c) => {
    const inIt = game && c.games.includes(game.id);
    return `<div class="backup-row data-row">
      <span class="data-info"><strong>${escapeHTML(c.name)}</strong> <small>${c.games.length} jogo(s)</small></span>
      <span class="data-actions">
        ${game ? `<button class="mini-btn${inIt ? ' is-on' : ''}" type="button" data-col-toggle="${escapeAttribute(c.id)}">${inIt ? '✓ Nesta coleção' : 'Adicionar'}</button>` : ''}
        <button class="mini-btn" type="button" data-col-rename="${escapeAttribute(c.id)}">Renomear</button>
        <button class="mini-btn mini-btn-danger" type="button" data-col-delete="${escapeAttribute(c.id)}">Apagar</button>
      </span>
    </div>`;
  });
  rows.push(`<div class="backup-row data-row"><span class="data-info"><small>${list.length ? 'Filtre o catálogo por uma coleção no campo "Lista".' : 'Crie listas como "Clássicos de luta" ou "Para sábado à noite".'}</small></span>
    <span class="data-actions"><button class="mini-btn" type="button" data-col-new="1">➕ Nova coleção</button></span></div>`);
  dom.collectionsList.innerHTML = rows.join('');
  dom.collectionsModal.classList.remove('is-hidden');
  if (!isLayerOpen('collections')) layerOpened('collections');
}

function closeCollectionsPanel() {
  if (!dom.collectionsModal) return;
  dom.collectionsModal.classList.add('is-hidden');
  layerClosed('collections');
  if (state.modalGame) updateGameModalExtras(state.modalGame);
}

async function handleCollectionsClick(event) {
  const game = state.collectionsGame;
  const toggle = event.target.closest('[data-col-toggle]');
  if (toggle && game) { toggleGameInCollection(toggle.dataset.colToggle, game.id); openCollectionsPanel(game); return; }
  const rename = event.target.closest('[data-col-rename]');
  if (rename) {
    const current = loadCollections().find((c) => c.id === rename.dataset.colRename);
    const name = await openPromptLayer({ title: 'Renomear coleção', label: 'Nome', value: current ? current.name : '' });
    if (name) renameCollection(rename.dataset.colRename, name);
    openCollectionsPanel(game);
    return;
  }
  const del = event.target.closest('[data-col-delete]');
  if (del) {
    if (!armButtonConfirm(del)) return;
    deleteCollection(del.dataset.colDelete);
    openCollectionsPanel(game);
    return;
  }
  if (event.target.closest('[data-col-new]')) {
    const name = await openPromptLayer({ title: 'Nova coleção', label: 'Nome da coleção', placeholder: 'Ex.: Clássicos de luta' });
    const created = name ? createCollection(name) : null;
    if (created && game) toggleGameInCollection(created.id, game.id);
    openCollectionsPanel(game);
  }
}

/* --- Extras do modal de detalhes do jogo --------------------------------- */

function updateGameModalExtras(game) {
  if (!game) return;
  if (dom.gameModalLater) {
    const later = isPlayLater(game.id);
    dom.gameModalLater.innerHTML = `<span class="btn-icon" aria-hidden="true">⏳</span> ${later ? 'Na fila' : 'Jogar depois'}`;
    dom.gameModalLater.setAttribute('aria-pressed', later ? 'true' : 'false');
  }
  if (dom.gameModalOffline) {
    dom.gameModalOffline.classList.toggle('is-hidden', Boolean(game.isLocal) || !offlineCacheAvailable());
    const status = offlineStatus(game);
    dom.gameModalOffline.innerHTML = `<span class="btn-icon" aria-hidden="true">✈️</span> ${status === 'none' ? 'Disponível offline' : status === 'ready' ? 'Offline ✓' : 'Offline (falta núcleo)'}`;
    dom.gameModalOffline.title = status === 'none' ? 'Baixar a ROM para jogar sem internet' : `${describeOfflineStatus(game)} — toque para remover`;
  }
}

// @generated-exports
export { closeCollectionsPanel, createCollection, deleteCollection, handleCollectionsClick, isPlayLater, loadCollections, loadPlayLater, matchesListFilter, openCollectionsPanel, renameCollection, renderListFilterOptions, saveCollections, toggleGameInCollection, togglePlayLater, updateGameModalExtras };
// @generated-exports
